/**
 * section-faq.js
 *
 * Progressive enhancement over native <details>/<summary>:
 *   1. Single-open mode (optional per section).
 *   2. Real height animation on both open AND close — native <details> can't
 *      transition closing because the content is display:none the instant the
 *      open attribute is removed, so we hold the attribute until the animation
 *      finishes.
 *   3. Deep links — /page#faq-shipping opens and scrolls to that question.
 *
 * With JS off, everything still opens, closes and is findable via ctrl+F.
 */
(function () {
  'use strict';

  var EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var DURATION = 320;

  function prefersReduced() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function Item(details) {
    this.el = details;
    this.summary = details.querySelector('summary');
    this.panel = details.querySelector('.faq__answer');
    this.animation = null;
    this.closing = false;
    this.expanding = false;
  }

  Item.prototype.onClick = function (event) {
    event.preventDefault();
    this.el.style.overflow = 'hidden';

    if (this.closing || !this.el.open) {
      this.open();
    } else if (this.expanding || this.el.open) {
      this.close();
    }
  };

  Item.prototype.animate = function (from, to, expanding) {
    if (this.animation) this.animation.cancel();

    this.animation = this.el.animate(
      { height: [from, to] },
      { duration: DURATION, easing: EASE }
    );

    this.expanding = expanding;
    this.closing = !expanding;

    var self = this;
    this.animation.onfinish = function () {
      self.finish(expanding);
    };
    this.animation.oncancel = function () {
      self.expanding = false;
      self.closing = false;
    };
  };

  Item.prototype.open = function () {
    if (prefersReduced()) {
      this.el.open = true;
      return;
    }

    var start = this.el.offsetHeight + 'px';
    this.el.style.height = start;
    this.el.open = true;

    var self = this;
    window.requestAnimationFrame(function () {
      var end = self.summary.offsetHeight + self.panel.offsetHeight + 'px';
      self.animate(start, end, true);
    });
  };

  Item.prototype.close = function () {
    if (prefersReduced()) {
      this.el.open = false;
      return;
    }

    var start = this.el.offsetHeight + 'px';
    var end = this.summary.offsetHeight + 'px';
    this.animate(start, end, false);
  };

  Item.prototype.finish = function (expanding) {
    this.el.open = expanding;
    this.animation = null;
    this.closing = false;
    this.expanding = false;
    this.el.style.height = '';
    this.el.style.overflow = '';
  };

  function initList(list) {
    if (list.dataset.faqReady === 'true') return;
    list.dataset.faqReady = 'true';

    var single = list.dataset.faqSingle === 'true';
    var items = [];

    list.querySelectorAll('[data-faq-item]').forEach(function (details) {
      var item = new Item(details);
      items.push(item);
      details.faqItem = item;

      item.summary.addEventListener('click', function (event) {
        item.onClick(event);

        if (single && !details.open) {
          items.forEach(function (other) {
            if (other !== item && other.el.open) other.close();
          });
        }
      });
    });

    return items;
  }

  function openFromHash(scope) {
    if (!window.location.hash) return;
    var target;
    try {
      target = (scope || document).querySelector(window.location.hash);
    } catch (error) {
      return; // Not a valid selector — nothing to do.
    }
    if (!target) return;

    var details = target.closest ? target.closest('[data-faq-item]') : null;
    if (!details) return;

    details.open = true;
    details.scrollIntoView({ behavior: prefersReduced() ? 'auto' : 'smooth', block: 'center' });
  }

  function init(scope) {
    (scope || document).querySelectorAll('[data-faq-list]').forEach(initList);
    openFromHash(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor */
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var details = event.target.closest('[data-faq-item]');
    if (details) details.open = true;
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var details = event.target.closest('[data-faq-item]');
    if (details && details.dataset.keepOpen !== 'true') details.open = false;
  });
})();
